
export const searchData = {
  tours: [
    { name: 'Brooklyn Heights Cat Tour', path: '/tours/brooklyn-heights' },
    { name: 'Financial District Cat Tour', path: '/tours/financial-district' },
    { name: 'Lower East Side Cat Tour', path: '/tours/lower-east-side' },
    { name: 'Private Cat Tours', path: '/tours/private-tours' }
  ],
  pages: [
    { name: 'About Us', path: '/about' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' },
    { name: 'Press Kit', path: '/press-kit' },
    { name: 'Book Now', path: '/booking' },
    { name: 'In the News', path: '/in-the-news' },
    { name: 'Site Map', path: '/sitemap' }
  ]
};
